import {
  Card,
  FormLayout,
  InlineStack,
  TextField,
  Thumbnail,
  Select,
  Button,
  Text,
  Divider,
} from "@shopify/polaris";

const BasicCouponDetails = ({
  code,
  setCode,
  title,
  setTitle,
  discountType,
  discountValue,
  setDiscountType,
  setDiscountValue,
  editable,
  appliesTo,
  setAppliesTo,
  selectedBundles,
  handleModalToggle,
  handleBundleSelection,
  setSelectedBundles,
}) => {
  return (
    <Card title="Coupon Basic Details" sectioned>
      <FormLayout>
        <Select
          label="Discount Type"
          options={[
            { label: "Percentage", value: "percentage" },
            { label: "Fixed Amount", value: "fixed_amount" },
          ]}
          value={discountType}
          onChange={setDiscountType}
          disabled={!editable}
        />
        <TextField
          label="Title"
          value={title}
          placeholder="e.g. 10% off on gifts"
          onChange={(value) => setTitle(value)}
          disabled={!editable}
        />
        <TextField
          label="Coupon Code"
          value={code}
          placeholder="e.g. GIFT10"
          onChange={(value) => setCode(value)}
          disabled={!editable}
        />
        <TextField
          label="Discount Value"
          value={discountValue}
          placeholder="e.g. 10"
          onChange={(value) => setDiscountValue(value)}
          type="number"
          max={discountType === "percentage" ? 100 : 1000000}
          prefix={discountType === "percentage" ? "%" : "₹"}
          disabled={!editable}
        />

        <Select
          label="Applies To"
          options={[
            { label: "All", value: "all" },
            { label: "Specific Products", value: "products" },
          ]}
          value={appliesTo}
          onChange={(value) => {
            setSelectedBundles([]);
            setAppliesTo(value);
          }}
          disabled={!editable}
        />
        {appliesTo === "products" && (
          <Button onClick={handleModalToggle} disabled={!editable}>
            Add Items
          </Button>
        )}
        {selectedBundles.length > 0 && (
          <Card title="Selected Products" sectioned>
            {selectedBundles.map((bundle, i) => {
              return (
                <>
                  <InlineStack gap="400" key={bundle._id} align="start">
                    <Thumbnail
                      source={bundle.coverImage?.url}
                      alt="Cover Photo"
                      size="small"
                    />
                    {/* <InlineStack> */}
                    <Text>{bundle.name}</Text>
                    <Text>₹{bundle.price}</Text>
                    <div>
                      <Button onClick={() => handleBundleSelection(bundle)}>
                        Remove
                      </Button>
                    </div>
                    {/* </InlineStack> */}
                  </InlineStack>
                  <br />
                  <Divider />
                  <br />
                </>
              );
            })}
          </Card>
        )}
      </FormLayout>
    </Card>
  );
};

export default BasicCouponDetails;
